export default "__VITE_ASSET__Cj7cwAUI__"